import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { FiLogIn, FiLock } from 'react-icons/fi';
import * as Yup from 'yup';

import { AxiosError } from 'axios';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';
import logo from '../../assets/logo.svg';

import { Content, AnimationContainer, Background } from './styles';

import Input from '../../components/Input';
import Button from '../../components/Button';

interface LoginRequest {
  login: string;
  senha: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const { signIn } = useAuth();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: LoginRequest) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          login: Yup.string().required('Informe seu login.'),
          senha: Yup.string().required('Informe sua senha.'),
        });

        await schema.validate(data, { abortEarly: false });

        await signIn({ login: data.login.toLowerCase(), senha: data.senha });
      } catch (err) {
        console.log(err);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          return;
        }

        if (
          (err as AxiosError)?.response?.data?.message.includes(
            'Usuário desativado',
          )
        ) {
          addToast({
            type: 'error',
            title: 'Usuário desabilitado',
            description:
              'Entre em contato com sua empresa e verifique seus status.',
          });
        } else {
          addToast({
            type: 'error',
            title: 'Erro na autenticação',
            description:
              'Ocorreu um erro ao fazer login. Cheque suas credenciais.',
          });
        }
      }
    },
    [signIn, addToast],
  );

  return (
    <>
      <Content>
        <AnimationContainer>
          <div>
            <img src={logo} alt="Atac Sistemas" style={{ width: 180 }} />
            <span>Login no painel administrativo do Atac Delivery</span>
          </div>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input name="login" icon={FiLogIn} placeholder="login" />
            <Input
              name="senha"
              icon={FiLock}
              type="password"
              placeholder="senha"
            />

            <Button type="submit">Entrar</Button>

            <Link to="forgot">Esqueci minha senha</Link>
          </Form>

          <aside>
            <span className="contato">
              Não tem uma conta? <Link to="contact">Cadastre sua loja!</Link>
            </span>

            <p>
              Desenvolvido por <strong>Atac Delivery</strong>
              <span>Todos os direitos reservados</span>
            </p>
          </aside>
        </AnimationContainer>
      </Content>

      <Background />
    </>
  );
};

export default SignIn;
